import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, array, string, bool } from "prop-types";

import DfpAd from "../../../dfp-ad";
import Organism1 from "../Organism1";
import NewsWithNoImage from "../../../molecules/NewsWithNoImage";

import "./row1.m.css";

const Row1 = ({
  stories,
  publisherAttributes,
  collectionSlug,
  adSlotId2,
  newsSectionArray,
  widgetUrl,
  showSectionTag,
  selectedTagName,
  headlineSpecialColor,
}) => {
  const row1FirstStories = stories.slice(0, 1);
  const row1SecondStories = stories.slice(1, 2);

  const latestNewsSection = newsSectionArray && newsSectionArray.latestNews ? newsSectionArray.latestNews : "";

  return (
    <React.Fragment>
      {row1FirstStories && (
        <Organism1
          story={row1FirstStories[0].story}
          sectionData={latestNewsSection}
          showSectionTag={showSectionTag}
          selectedTagName={selectedTagName}
          headlineSpecialColor={headlineSpecialColor}
        />
      )}

      <div styleName="ads">
        <div styleName="inner_ads">
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="HomeFeaturedR1Ads"
            slotId={adSlotId2}
          />
        </div>
      </div>
      <div styleName="second_story" className={widgetUrl ? "widget-present" : ""}>
        {row1SecondStories && (
          <NewsWithNoImage
            story={row1SecondStories[0].story}
            sectionData={latestNewsSection}
            showSectionTag={showSectionTag}
            datatrackinglabelpos={2}
            selectedTagName={selectedTagName}
            headlineSpecialColor={headlineSpecialColor}
          />
        )}
        {widgetUrl && (
          <div styleName="widget-available">
            <iframe src={widgetUrl} styleName="widget-iframe"></iframe>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
  collectionSlug: string,
  adSlotId2: string,
  newsSectionArray: object,
  widgetUrl: string,
  showSectionTag: bool,
  selectedTagName: string,
  headlineSpecialColor: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(Row1);
